<section #dropdown (click)="toggleDropdown($event)">
  <ng-content></ng-content>
</section>
